import React from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { Box, Container } from '@mui/material';

import connectWithUserStore from '../reducers/connectWithUserStore';
import Loading from '../containers/Loading';
import MGPHubView from '../containers/MGPHubView';
import NextStepsContainer from '../containers/NextStepsContainer';
import ModalProvider from './modals/ModalProvider';
import BlueBanner from './shared/BlueBanner';
import IntroTile from './shared/IntroTile';
import SessionTimerModal from './modals/SessionTimerModal';
import AdviceFooterImpl from './shared/Footer/AdviceFooterImpl';
import { BASE_URL } from './shared/Links';

function Router({ state, applicationConfig }) {
    const { isAuthenticated } = state;

    // Placeholder - should be updated once iframe is ready
    const emptyContent = () => {
        return <div />;
    };

    // Send user to logged-in landing page (MGP)
    const ifLoggedIn = (Component) => () => {
        console.log('send to login / secure url');
        return isAuthenticated ? (
            <Navigate to={"/secure" + window.location.search} replace />
        ) : (
            <Container maxWidth="xl" style={{ padding: '0px' }}>
                <Component />
            </Container>
        );
    };

    console.log('Router isAuthenticated', isAuthenticated);
    return (
        <div>
            <React.Suspense fallback={<Loading />}>
                <BrowserRouter basename={BASE_URL}>
                    <ModalProvider>
                        <Box style={{ padding: '0px' }}>
                            <BlueBanner />
                            <IntroTile applicationConfig={applicationConfig} />
                        </Box>
                        <Routes>
                            <Route
                                exact
                                path="/"
                                element={ifLoggedIn(emptyContent)()}
                            />
                            <Route
                                exact
                                path="/secure"
                                element={
                                    <React.Fragment>
                                        <Container style={{ padding: '0px', minWidth: '100%' }}>
                                            <h1 style={{ display: 'none' }}>Personal information</h1>
                                            <MGPHubView applicationConfig={applicationConfig} />
                                        </Container>
                                    </React.Fragment>
                                }
                            />
                            <Route
                                exact
                                path="/next-steps"
                                element={
                                    <>
                                        <NextStepsContainer applicationConfig={applicationConfig} />
                                    </>
                                }
                            />
                            <Route
                                path="*"
                                element={<Navigate to="/" replace />}
                            />
                        </Routes>
                        <SessionTimerModal applicationConfig={applicationConfig} />
                        <AdviceFooterImpl />
                    </ModalProvider>
                </BrowserRouter>
            </React.Suspense>
        </div>
    );
}

export default connectWithUserStore(Router);